import { axios } from '@/di-container/axios';
import {
  GetGnbListGateway,
  GetMenusGateway,
  GetComponentDataGateway,
  GetDisplayInfoGateway,
  GetTemplateInfoGateway,
  GetComponentListGateway,
  GetHamburgerMenusGateway,
} from '@remodeling/content';

export const displayGateway = () => {
  return {
    getMenus: new GetMenusGateway(axios),
    getGnb: new GetGnbListGateway(axios),
    getHamburgerMenus: new GetHamburgerMenusGateway(axios),
    getDisplayInfo: new GetDisplayInfoGateway(axios),
    getTemplateInfo: new GetTemplateInfoGateway(axios),
    getComponentData: new GetComponentDataGateway(axios),
    getComponentList: new GetComponentListGateway(axios),
  };
};
